import { Block, BorderStyleProperty, Flex } from '@aloft/toolkit-sui';

import { borderStyle } from '../../styles/border.ts';
import { ValuationTablePropertyHeaderFirstLine } from './ValuationTablePropertyHeaderFirstLine.tsx';
import { ValuationTablePropertyHeaderImage } from './ValuationTablePropertyHeaderImage.tsx';
import { ValuationTablePropertyHeaderSecondLine } from './ValuationTablePropertyHeaderSecondLine.tsx';
import { ValuationTablePropertyHeaderThirdLine } from './ValuationTablePropertyHeaderThirdLine.tsx';
import { ValuationTablePropertyHeaderProps } from './types.ts';

export const ValuationTablePropertyHeader = (props: ValuationTablePropertyHeaderProps) => {
  const { zIndex, backgroundColor, width } = props;
  return (
    <Block
      position="sticky"
      top="0"
      zIndex={zIndex}
      backgroundColor={backgroundColor ?? 'surface1'}
      width={width}
      borderWidth="1px"
      borderColor="strokeDefault"
      borderStyle={borderStyle as BorderStyleProperty}
      height="88px"
      boxShadow="0px 4px 8px 0px #0000000F"
    >
      <Flex width="100%">
        <ValuationTablePropertyHeaderImage {...props} />
        <Flex flexDirection="column" padding="8px" flexGrow={1} overflow="hidden">
          <ValuationTablePropertyHeaderFirstLine {...props} />
          <ValuationTablePropertyHeaderSecondLine {...props} />
          <ValuationTablePropertyHeaderThirdLine {...props} />
        </Flex>
      </Flex>
    </Block>
  );
};
